import { css } from '@emotion/react'
import CancelIcon from '@mui/icons-material/Cancel'
import { Badge } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { PendingRowTypeDisplayText, PendingStatus, DatasetStatus } from '@components'
import { StatusChip } from './statusChips'

const cancelIcon = css`
  margin: 4px 10px 0 0;
  font-size: 14px;
`

interface Props {
  status: PendingStatus | DatasetStatus
}

export const PendingStatusIndicator = ({ status }: Props) => {
  const { location } = useHistory()
  const onDetailsPage = location.pathname.includes('codes/details')
  const label = PendingRowTypeDisplayText[status] || status

  switch (status) {
    case PendingStatus.REJECTED:
      return onDetailsPage ? (
        <StatusChip
          status={PendingStatus.AWAITING_APPROVAL}
          label={PendingStatus.AWAITING_APPROVAL}
        />
      ) : (
        <Badge
          badgeContent={<CancelIcon color="error" css={cancelIcon} />}
          data-testid="badge"
          slotProps={{
            badge: {
              'data-testid': 'badge-counter',
            },
          }}
        >
          <StatusChip
            status={PendingStatus.AWAITING_APPROVAL}
            label={PendingStatus.AWAITING_APPROVAL}
            tooltipTitle={status}
          />
        </Badge>
      )
    default: {
      return <StatusChip status={status} label={label} />
    }
  }
}
